export const h = {
    "common": {
        "webSuffix": "- QIDI Tech",
        "email": "cassetta postale",
        "password": "password",
        "verificationCode": "Codice di verifica",
        "username": "nome utente",
        "readAndAgree": "Sono d'accordo",
        "and": "e",
        "userAgreement": "Accordo utente",
        "privacyPolicy": "Informativa sulla privacy",
        "copy": "copyright ©  A partire dal 2025, Di riserva la proprietà",
        "sendVerificationCode": "Invia codice di verifica",
        "Sending": "Invio",
        "tryAgainInSeconds": "Riprova tra pochi secondi",
        "userNameRequired": "inserisci un nome utente",
        "passwordInputLabel": "Inserisci una password",
        "checkPasswordInputLabel": "Inserisci la password di conferma",
        "userEmailRequired": "Inserisci il tuo indirizzo email",
        "userEmailInvalid": "Inserisci l'indirizzo email corretto",
        "emailCodeRequired": "Inserisci il codice di verifica",
        "newPasswordInputLabel": "Inserisci una nuova password",
        "confirmPasswordInputLabel": "Inserisci nuovamente la tua password",
        "passwordMismatchErrorLabel": "La password inserita due volte è incoerente",
        "agreementRequired": "Si prega di leggere e accettare l'accordo",
        "tip": "Consigli",
        "tipAlreadyLogin": "Rilevato che hai effettuato l'accesso, reindirizzato al centro utente per te",
        "tipWelcomeBack": "Bentornato~",
        "tipDeleteAccountFail": "Eliminazione dell'account non riuscita, l'interfaccia di eliminazione dell'account viene temporaneamente chiusa",
        "pleaseAgreeFirst": "Si prega di accettare prima",
        "agree": "accordo",
        "refuse": "rifiuti",
        "tipNeedLogin": "Si prega di accedere prima",
        "tipChangePasswordSuccess": "Password modificata correttamente, ti reindirizzeremo alla pagina di login",
        "tipGetUserInfoSuccess": "Informazioni ottenute con successo",
        "tipGetUserInfoFail": "ottenere informazioni errate",
        "tipLoginOut": "Esci e accedi",
        "delete": "elimina",
        "back": "ritorno",
        "init": "inizializzazione",

        "passwordInputLengthErrorLabel": "La lunghezza della password dovrebbe essere compresa tra 6 e 20",
        "changePasswordFail": "Password originale errata",
        "tipDeleteAccountSuccess": "Account eliminato correttamente",
        "emailCodeSentSuccess": "Il codice di verifica è stato rilasciato",
        "emailCodeSentFail": "Emissione del codice di verifica non riuscita",
        "emailLoginFail": "Il codice di verifica è scaduto",
        "passwordLoginFail": "Password di accesso errata",
        "editUserInfoSuccess": "Informazioni utente modificate con successo",
        "registerSuccess": "registrato con successo",
        "registerFail": "login non riuscito",
        "registerEmailExistFail": "L'email esiste già",

        "resMessageTip0": "informazioni sconosciute",
        "resMessageTip1": "Errore password",
        "resMessageTip2": "La lunghezza della password dovrebbe essere compresa tra 6 e 20",
        "resMessageTip3": "Errore dell'account",
        "resMessageTip4": "Il codice di verifica è stato rilasciato",
        "resMessageTip5": "Emissione del codice di verifica non riuscita",
        "resMessageTip6": "Il codice di verifica è scaduto",
        "resMessageTip7": "Errore password",
        "resMessageTip8": "La password non può essere la stessa della vecchia password",
        "resMessageTip9": "L'email esiste già",
        "resMessageTip10": "registrato con successo",
        "resMessageTip11": "login non riuscito",
        "resMessageTip12": "Informazioni utente modificate con successo",
        "resMessageTip13": "Modifica delle informazioni utente non riuscita",
        "resMessageTip14": "Ottenuto con successo",
        "resMessageTip15": "Acquisizione fallita",
        "resMessageTip16": "Password modificata correttamente",
        "resMessageTip17": "Modifica password non riuscita",
        "resMessageTip18": "Ripristino password riuscito",
        "resMessageTip19": "Ripristino della password non riuscito",
        "resMessageTip20": "Accesso riuscito",
        "resMessageTip21": "Accesso fallito",
        "resMessageTip22": "Account eliminato correttamente",
        "resMessageTip23": "Eliminazione account non riuscita",
        "resMessageTip24": "Il codice di verifica non è corretto",
        "noUserInfoError": "Errore di rete, accedi di nuovo"
    },
    "changePassword": {
        "newPassword": "Nuova password"
    },
    "deleteUser": {
        "tipDeleteUser": "Sfortunatamente, devi andartene. Una volta cancellato il tuo account, tutti i tuoi dati personali scompariranno definitivamente e non potranno essere recuperati.",
        "accountDeletionTerms": "Termini di cancellazione dell'account"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Recupera password tramite email",
        "confirmPassword": "Conferma password",
        "resettingPassword": "reimposta password",
        "resetting": "Ripristina"
    },
    "login": {
        "passwordLogin": "Accesso password",
        "verifyLogin": "Verifica login",
        "accountRegistration": "Registrazione del conto",
        "forgotPassword": "Password dimenticata",
        "login": "Accedi",
        "localLogin": "Accesso locale",
        "loginOut": "Esci",
        "continueOnYourWay": "Continua per la tua strada"
    },
    "register": {
        "registerAnAccount": "Registra un account",
        "register": "registro"
    },
    "userCenter": {
        "personalInformation": "dati personali",
        "modifyInformation": "Modifica informazioni",
        "changePassword": "Cambia password",
        "cancelAccount": "Annulla account",
        "exitAccount": "Esci dal conto",
        "change": "modificare",
        "maxCharLimitTip": "La lunghezza del nome utente non può superare i 10 caratteri cinesi",
    },
    "policies": {
        "deleteAccountPrivacy": "Elimina accordo account",
        "agreement": "Accordo di utilizzo",
        "privacyPolicy": "Informativa sulla privacy"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Scegli il tuo paese o la tua regione",
        "recommendedVisits": "Visita consigliata",
        "NorthAmerica": "Nord America",
        "Europe": "Europa",
        "Asia": "Asia",
        "Other": "altro",
    }
}
export const aAndL ={
    "ar": {
        "Country": "arabo",
        "Language": "Arabo"
    },
    "cs": {
        "Country": "Repubblica ceca",
        "Language": "Ceco"
    },
    "de": {
        "Country": "Germania",
        "Language": "Tedesco"
    },
    "en": {
        "Country": "britain",
        "Language": "Inglese"
    },
    "es": {
        "Country": "Spagna",
        "Language": "Spagnolo"
    },
    "fr": {
        "Country": "Francia",
        "Language": "Francese"
    },
    "he": {
        "Country": "Israele",
        "Language": "Ebraico"
    },
    "hu": {
        "Country": "Ungheria",
        "Language": "Lingua ungherese"
    },
    "it": {
        "Country": "Italia",
        "Language": "Italiano"
    },
    "ja": {
        "Country": "Giappone",
        "Language": "Giapponese"
    },
    "ko": {
        "Country": "la Repubblica di Corea",
        "Language": "Coreano"
    },
    "nl": {
        "Country": "Paesi Bassi",
        "Language": "Olandese"
    },
    "pt": {
        "Country": "Portogallo",
        "Language": "Portoghese"
    },
    "pt_BR": {
        "Country": "Portogallo (Brasile)",
        "Language": "Portoghese (Brasile)"
    },
    "ru": {
        "Country": "Russia",
        "Language": "Russo"
    },
    "sv": {
        "Country": "Svezia",
        "Language": "Lingua svedese"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Turco"
    },
    "uk": {
        "Country": "Ucraina",
        "Language": "Lingua ucraina"
    },
    "zh": {
        "Country": "Cina continentale",
        "Language": "Cinese semplificato"
    },
    "zh_tw": {
        "Country": "Taiwan, Cina",
        "Language": "Cinese tradizionale"
    },
    "Canada": {
        "Country": "Canada",
        "Language": "Inglese"
    },
    "United_States": {
        "Country": "U.S.A.",
        "Language": "Inglese"
    },
    "United_Kingdom": {
        "Country": "britain",
        "Language": "Inglese"
    },
    "EU_Countries": {
        "Country": "Paesi dell'UE",
        "Language": "Inglese"
    },
    "Australia": {
        "Country": "Australia",
        "Language": "Inglese"
    },
    "globalzh": {
        "Country": "Globale",
        "Language": "Cinese semplificato"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Inglese"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/it.js